/**
 * Step metadata used by both the WizardStepper and the wizard page wrapper.
 * Lives in its own file so HMR / fast-refresh stays clean (only exports
 * non-component values).
 *
 * COL-529: the V3 wizard is four steps — Objekt → Wohnungen → Checkliste →
 * Prüfung. `titleKey` is translated at render time via useLanguage(); `title`
 * is the English fallback shown when the key is missing.
 */
export type WizardStep = {
  n: number;
  titleKey: string;
  title: string;
};

export const WIZARD_STEPS: WizardStep[] = [
  { n: 1, titleKey: "admin.wizard.step.objekt", title: "Property" },
  { n: 2, titleKey: "admin.wizard.step.wohnungen", title: "Apartments" },
  { n: 3, titleKey: "admin.wizard.step.checkliste", title: "Checklist" },
  { n: 4, titleKey: "admin.wizard.step.pruefung", title: "Review" },
];
